import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useMemo } from 'react';
export var useIconList = function useIconList(_ref) {
  var icons = _ref.icons,
    iconTypeList = _ref.iconTypeList;
  return useMemo(function () {
    return icons.reduce(function (acc, icon) {
      if (!icon || !icon.iconMark) {
        return acc;
      }
      var isIconSingleButton = iconTypeList.includes(icon.iconMark);
      if (isIconSingleButton) {
        return {
          dropdownItems: acc.dropdownItems,
          singleItems: [].concat(_toConsumableArray(acc.singleItems), [icon])
        };
      }
      return {
        dropdownItems: [].concat(_toConsumableArray(acc.dropdownItems), [icon]),
        singleItems: acc.singleItems
      };
    }, {
      dropdownItems: [],
      singleItems: []
    });
  }, [icons, iconTypeList]);
};